var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "message isso-message", class: _vm.messageClass },
    [
      _c("div", { staticClass: "message-body" }, [
        _c("div", { staticClass: "information level is-marginless" }, [
          _c("span", { staticClass: "label level-left" }, [
            _vm._v(_vm._s(_vm.authorName(_vm.author)))
          ]),
          _c("span", { staticClass: "level-right" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.timeFromNow(_vm.created)) + "\n      "
            )
          ])
        ]),
        _c("div", { staticClass: "text" }, [
          _c("p", [
            _vm._v("\n        " + _vm._s(_vm.showtext(_vm.text)) + "\n      ")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }